import { SimpleGrid, Box, Heading } from "@chakra-ui/react";
import { CaseStudyDetails } from "./Components/CaseStudyDetails";
import TechLayout from "./TechLayout";
import { useParams } from 'react-router-dom';
import { useEffect } from "react";

export const CaseStudyDetailsPage = () => {
  const { case_study_id } = useParams<{ case_study_id: string }>();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [case_study_id]);

  return (
    <TechLayout>
      <Box as="section" p={6} maxWidth="1200px" mx="auto">
        {/* Top heading with id for anchor linking */}
        <Heading id="casestudy" mb={6} size="lg">
          Case Study Details
        </Heading>

        {/* Render the actual details */}
        <CaseStudyDetails id={case_study_id!} mode="dark" />
      </Box>
    </TechLayout>
  );
};
